import * as React from "react";
import {
    List,
    Show,
    Edit,
    Create,

    Datagrid,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    EmailField,
    DateField,
    TextInput,
    DateInput,
    BooleanField,
    ArrayField,
    SelectField,
    SelectInput,

    TabbedShowLayout,
    Tab,
    Toolbar,
    SaveButton,
    useRecordContext,
    Button,
    NumberField,
    NumberInput,
    FormDataConsumer,
    WrapperField,
    FunctionField,
    TopToolbar,
    EditButton,
    Confirm,
    useDataProvider,
    useRedirect,
    useNotify,
    TabbedForm,
    ArrayInput,
    SimpleFormIterator,
    RichTextField,
    ReferenceInput,
    AutocompleteInput,
    Link,
    BooleanInput,
    FileInput,
    FileField,
} from 'react-admin';
import Grid from '@mui/material/Grid';
import { formStatuses, getStatuses, toSelectChoices } from "../helpers/strings";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { RichTextInput } from "ra-input-rich-text";
import { AdditionalSchemaInput } from "../Components/AdditionalSchema";
import { FormEditChildToolbar } from "../Components/FormEditChildToolbar";

const listFilters = [
    <TextInput source="q" label="Search" alwaysOn />,
];

const FormBaselineRequirementList = props => (
    <List title={"All Baseline Requirements"} filters={listFilters} {...props} hasCreate>
        <Datagrid rowClick="show">
            <TextField source="name" />
            {/* <FunctionField label="Status" source="status" render={record => formStatuses[record.status] ?? record.status} /> */}

            <TextField label="Form" source="form.name" />
        </Datagrid>
    </List>
);

const FormPreview = () => {
    const record = useRecordContext();
    // the record can be empty while loading
    if (!record) return null;

    return (<>
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Title</TableCell>
                    {/* <TableCell align="right">LP</TableCell> */}
                    {/* <TableCell align="right">CP</TableCell> */}
                    {/* <TableCell align="right">MSA</TableCell> */}
                </TableRow>
                </TableHead>
                <TableBody>
                {record.key_indicators.map((keyIndicator) => (<React.Fragment key={keyIndicator.name}>
                    <TableRow
                        sx={{ '& > *': {fontStyle: 'italic'}, '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <TableCell component="th" scope="row">
                            <Link to={`/form-key-indicators/${keyIndicator.id}/show`}>
                                {keyIndicator.name}
                            </Link>
                        </TableCell>
                        {/* <TableCell align="right">{scoreFor('keyIndicator', keyIndicator).lp}</TableCell> */}
                        {/* <TableCell align="right">{scoreFor('keyIndicator', keyIndicator).cp}</TableCell> */}
                        {/* <TableCell align="right">{scoreFor('keyIndicator', keyIndicator).msa}</TableCell> */}
                    </TableRow>
                    {keyIndicator.indicators.map((indicator) => (<React.Fragment key={indicator.name}>
                        <TableRow
                            sx={{ 'th': {paddingLeft: 6}, '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                <Link to={`/form-indicators/${indicator.id}/show`}>
                                    {indicator.name}
                                </Link>
                            </TableCell>
                            {/* <TableCell align="right">{scoreFor('indicator', indicator).lp}</TableCell> */}
                            {/* <TableCell align="right">{scoreFor('indicator', indicator).cp}</TableCell> */}
                            {/* <TableCell align="right">{scoreFor('indicator', indicator).msa}</TableCell> */}
                        </TableRow>
                    </React.Fragment>))}
                </React.Fragment>))}
                </TableBody>
            </Table>
        </TableContainer>
    </>);
};
const FormBaselineRequirementShow = props => (
    <Show {...props}>
        {/* <SimpleShowLayout> */}
        <TabbedShowLayout>
            <Tab label="summary">
                <TextField source="name" />

                <TextField label="Form" source="form.name" />

                {/* sequence */}

                <BooleanField label="Require file upload?" source="has_file_upload" looseValue />
                {/* Example files */}

                <RichTextField source="description"/>
            </Tab>
            {/*
            <Tab label="Table of Contents">
                <em>Click on a title to navigate to that specific section.</em>
                <FormPreview/>
            </Tab>
            */}
        {/* </SimpleShowLayout> */}
        </TabbedShowLayout>
    </Show>
);

export const FormBaselineRequirementEditForm = () => (
    <TabbedForm toolbar={<FormEditChildToolbar resource="form-baseline-requirements" deletable />}>
        <TabbedForm.Tab label="Summary">
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextInput source="name" isRequired fullWidth />
                </Grid>
                <Grid item xs={6}>
                    <ReferenceInput source="form_id" perPage={-1} reference="forms">
                        <AutocompleteInput optionText="name" isRequired fullWidth />
                    </ReferenceInput>
                </Grid>
            </Grid>

            {/* sequence */}
            {/* <NumberInput source="sequence" label="Order" /> */}

            <RichTextInput source="description"/>

            <BooleanInput source="has_file_upload" label="Require file upload?" />

            <FileInput source="media" label="Example File" multiple>
                <FileField source="original_url" title="file_name" />
            </FileInput>
        </TabbedForm.Tab>
        <TabbedForm.Tab label="Additional Questions">
            <AdditionalSchemaInput excludedQuestionTypes={['file']} />
        </TabbedForm.Tab>
    </TabbedForm>
);

const FormBaselineRequirementEdit = props => (
    <Edit {...props} redirect="show" mutationMode="pessimistic">
        <FormBaselineRequirementEditForm/>
    </Edit>
);

const FormBaselineRequirementCreate = props => {
  return (
    <Create {...props} redirect="show">
        <TabbedForm toolbar={<FormEditChildToolbar resource="form-baseline-requirements" />}>
            <TabbedForm.Tab label="Summary">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextInput source="name" isRequired fullWidth />
                    </Grid>
                    <Grid item xs={6}>
                        <ReferenceInput source="form_id" perPage={-1} reference="forms">
                            <AutocompleteInput optionText="name" isRequired fullWidth />
                        </ReferenceInput>
                    </Grid>
                </Grid>

                {/* sequence */}
                {/* <NumberInput source="sequence" label="Order" /> */}

                <RichTextInput source="description"/>

                <BooleanInput source="has_file_upload" label="Require file upload?" />

                <FileInput source="media" label="Example File" multiple>
                    <FileField source="original_url" title="file_name" />
                </FileInput>
            </TabbedForm.Tab>
            <TabbedForm.Tab label="Additional Questions">
                <AdditionalSchemaInput/>
            </TabbedForm.Tab>
        </TabbedForm>
    </Create>
)
};

export {FormBaselineRequirementList, FormBaselineRequirementShow, FormBaselineRequirementEdit, FormBaselineRequirementCreate};
